
const InvoiceDetailsUrlPrefix = '/invoice-details';
export const invoiceDetailsUrl = (invoiceId: string) => `${InvoiceDetailsUrlPrefix}/${invoiceId}`;
export const InvoiceDetailsUrlInvoiceIdParamName = 'invoiceId';
export const InvoiceDetailsUrlMapping = `${InvoiceDetailsUrlPrefix}/:${InvoiceDetailsUrlInvoiceIdParamName}`;